import { IncomeField } from './IncomeField.tsx';
import { IncomeFieldDate } from './IncomeFieldDate.tsx';
import { IncomeFieldNote } from './IncomeFieldNote.tsx';
import { IncomeRow } from './IncomeRow.tsx';
import { type IncomeType, incomeTypeConfig } from './incomeTypeConfig.ts';
import type { IncomeFormState } from '../hooks/useIncomeForm.ts';

type Props = {
    id: string;
    index: number;
    isSecondApplicant: boolean;
    onDelete: IncomeFormState['onDelete'];
    type: IncomeType;
};

export const IncomeItem: React.FC<Props> = ({ id, index, isSecondApplicant, onDelete, type }) => {
    const config = incomeTypeConfig[type];
    const isSecondaryEmployment = type === 'einkuenfteAusNebentaetigkeit';
    const isOtherIncome = type === 'sonstigeEinnahmen';
    const hasSubField = isSecondaryEmployment || isOtherIncome;

    return (
        <IncomeRow
            onDelete={() => onDelete(type, id)}
            isSecondApplicant={isSecondApplicant}
            removeCommandName={config.removeCommand}
        >
            <div className={hasSubField ? 'flex flex-col gap-2' : undefined}>
                <IncomeField
                    name={`${type}.${index}.betragMonatlich`}
                    label={config.label}
                    isSecondApplicant={isSecondApplicant}
                    commandName={config.changeCommand}
                />
                {isSecondaryEmployment && (
                    <IncomeFieldDate
                        name={`einkuenfteAusNebentaetigkeit.${index}.beginnDerTaetigkeit`}
                        isSecondApplicant={isSecondApplicant}
                        commandName={config.changeCommand}
                    />
                )}
                {isOtherIncome && (
                    <IncomeFieldNote
                        name={`sonstigeEinnahmen.${index}.notiz`}
                        isSecondApplicant={isSecondApplicant}
                        commandName={config.changeCommand}
                    />
                )}
            </div>
        </IncomeRow>
    );
};
